import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError, BehaviorSubject } from 'rxjs';
import { IUser } from '../interfaces/iuser';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssignOfficerService {

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private ASSIGN_URL:string = this.BASE_URL+"assign";
  private _officer: Array<IUser>;
  
 
  constructor(private http : HttpClient) { 
    this._officer = [];
  }

  public get officer(): Array<IUser> {
    return this._officer;
  }

  public getOfficers():Observable<any>{
    if (this._officer.length>0) {
      return new BehaviorSubject(true);
    }
    return this.http.get<any>(this.ASSIGN_URL).pipe(
      map( res =>{
        this._officer = res;
        return true;
      }),
      catchError(this.errorHandler));
  }
  errorHandler(error : HttpErrorResponse){
     return observableThrowError(error.message || "Server Error");
   }

   public getUserByTeam(teamNo: number): IUser[]{
      return this._officer.filter(x => x.TEAM_NO === teamNo);
   }

   public assignRequestToOfficer(asm : IAssignModel){
    return this.http.put<any>(this.ASSIGN_URL, asm)

   }
}
